/*
 * Copyright (c) 2022 CalAmp Corp.  All Rights Reserved
 */
import React from 'react';
import GlobalGroupsQueryResultsItems from './GlobalGroupsQueryResultsItems';
import GlobalGroupsSearchCount from './GlobalGroupsSearchCount';

interface GroupQueryResultProps {
  searchValue: string;
  onViewSubaccounts: Function;
  handleCrumbClick: Function;
  hideParentAccount?: boolean;
  onContentScrollToTop?: Function;
}

/**
 * Component to display Global Groups Count and Search Results
 * ```typescript
 *  import GroupsQueryResult from '@ion/dls/src/components/groupchooser/GroupsQueryResult';
 *
 *  <GroupsQueryResult searchValue={searchValue}
 *    onViewSubaccounts={setSelectedSearchValue}/>
 * ```
 */
const GroupsQueryResult = ({
  searchValue,
  onViewSubaccounts,
  handleCrumbClick,
  onContentScrollToTop,
  hideParentAccount = false
}: GroupQueryResultProps) => {
  return (
    <>
      <GlobalGroupsSearchCount searchValue={searchValue}/>
      <GlobalGroupsQueryResultsItems searchValue={searchValue}
        hideParentAccount={hideParentAccount}
        onViewSubaccounts={onViewSubaccounts}
        handleCrumbClick={handleCrumbClick}
        onContentScrollToTop={onContentScrollToTop}/>
    </>
  );
};

export default GroupsQueryResult;
